---
pageId: feature-templates
title: Tracker templates
description: A curated library of ready-made trackers — 30 templates across 7 life areas, each with sensible metrics preconfigured.
category: features
order: 2
lang: en
slug: features/templates
updated: 2026-08-05
---

Templates answer the blank-page problem. Instead of deciding metrics, units and scales up front, you start from a curated tracker and adjust it to your life.

## What's in the library

The catalog holds 30 ready templates across seven areas:

- **Health** — Water, Sleep, Weight, Steps, Supplements
- **Sport** — Running, Gym, Cycling, Swimming, Yoga
- **Mind** — Mood, Meditation, Stress, Gratitude
- **Relationships** — Family time, Call loved ones, Friends contact, Date night
- **Hobby** — Reading, Creative project, Instrument, Gaming
- **Work** — Deep work, Pomodoro, Meetings, Professional learning
- **Finance** — Daily spending, No-spend day, Savings, Impulse buys

## What a template preconfigures

Each template ships a name, a description, a color, an icon and an ordered set of metrics — with types, units, scale bounds and how each entry updates the value already decided. The first metric is the primary one. Templates keep to at most 3 metrics, so every one of them fits the Free plan.

## Where you meet templates

**During your first sign-in**, the welcome screen offers seven starters — Water, Sleep, Steps, Gym, Mood, Reading, Deep work. Select any number and press **Add selected**: the trackers are created immediately, each filed under a matching category (Health, Sport, …) that Samlla creates for you if needed.

**On the creation page** (**Create Tracker**), the full catalog sits behind the seven category pills. Here a template works differently: clicking one pre-fills the creation form and nothing is created yet. Review the metrics — adjust types, units or the schedule — and only **Create Tracker** saves it. Each further template click overwrites the form, so you can browse freely.

## Templates are a starting point

A tracker created from a template is a regular tracker. Rename it, recolor it, add or deactivate metrics, change the schedule — nothing about its origin constrains it.
